<template>
  <div class="base-height_fullscreen">
    <div class="base-margin__bottom-10 base-flex">
      <el-select v-model="userId" :placeholder="$t('logManagement.selectUser')" class="select-width__230" clearable
                 filterable
                 @change="getList">
        <el-option
          v-for="item in userList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
          <span>{{ item.name }} {{ `${item.remark !== '' ? `(${item.remark})` : ''}` }}</span>
        </el-option>
      </el-select>
      <el-select v-model="projectId" :placeholder="$t('logManagement.selectProject')" class="select-width__230" clearable
                 filterable
                 @change="getList">
        <el-option
          v-for="item in projectList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="scene" :placeholder="$t('logManagement.selectScene')" class="select-width__230" clearable
                 filterable
                 @change="getList">
        <el-option
          v-for="item in sceneList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-input v-model="activityId" :placeholder="$t('logManagement.enterActivityId')" class="select-width__230"
                @change="getList"></el-input>
      <el-input v-model="actionId" :placeholder="$t('logManagement.enterActionId')" class="select-width__230"
                @change="getList"></el-input>
      <el-input v-model="requestId" :placeholder="$t('logManagement.enterRequestId')" class="select-width__230"
                @change="getList"></el-input>
    </div>
    <el-table v-loading="tableLoading" :data="tableData" class="log_table">
      <el-table-column :label="$t('logManagement.instanceId')" prop="instanceId" width="100"></el-table-column>
      <el-table-column :label="$t('logManagement.userId')" prop="userId"></el-table-column>
      <el-table-column :label="$t('logManagement.projectId')" prop="projectId"></el-table-column>
      <el-table-column :label="$t('logManagement.action')" prop="action"></el-table-column>
      <el-table-column :label="$t('logManagement.actionId')" prop="actionId"></el-table-column>
      <el-table-column :label="$t('logManagement.requestId')" prop="requestId"></el-table-column>
      <el-table-column :label="$t('logManagement.activityId')" prop="activityId"></el-table-column>
      <el-table-column
        :label="$t('logManagement.actions')"
        width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="deleteLog(scope.row)">{{ $t('logManagement.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      :page-size="10"
      :page-sizes="[10, 20, 50, 100]"
      :total="tableDataTotal"
      align="right"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="onCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';

export default {
  name: 'describeOperation',
  data() {
    return {
      tableData: [], // 用户操作列表
      tableDataTotal: 0, // 任务总数
      userId: '', // 用户ID
      userList: [], // 用户列表
      projectList: [], // 项目列表
      projectId: '', // 项目ID
      currentPage: 1,
      pageSize: 10,
      activityId: '',
      actionId: '',
      requestId: '',
      scene: 'cluster',
      sceneList: ['cluster'],
      tableLoading: false,
      getClsLogList: [],
    };
  },
  created() {
    this.getUserList();  // 获取用户列表项目列表
    this.getList();
  },

  methods: {
    /**
     * 查询用户操作列表
     */
    getList() {
      this.tableLoading = true;
      const params = {
        scene: 'cluster',
        fields: {
          requestId: this.requestId,
          actionId: this.actionId,
          activityId: this.activityId,
          userId: this.userId.toString(),
          projectId: this.projectId.toString(),
        }
      };
      postRequest('/api/eda/common/admin/getClsLogList', params).then((res) => {
        this.getClsLogList = res?.list || [];
        this.tableDataTotal = res?.total || 0;
        this.vuePagination();
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    /**
     * 删除日志
     * */
    deleteLog(data) {
      this.$confirm(this.$t('logManagement.deleteConfirm'), this.$t('logManagement.tip'), {
        confirmButtonText: this.$t('logManagement.confirm'),
        cancelButtonText: this.$t('logManagement.cancel'),
        type: 'warning'
      }).then(() => {
        const params = {
          fields: {
            actionId: data.actionId,
          },
        };
        postRequest('/api/eda/common/admin/delClsLog', params).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('logManagement.deleteSuccess')
          });
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('logManagement.cancelDelete')
        });
      });
    },

    /**
     * 查询用户操作列表
     */
    getUserList() {
      getRequest('/api/eda/common/admin/getUserList?offset=0&limit=999').then((res) => {
        res?.list.unshift({
          id: '',
          name: this.$t('logManagement.all'),
          remark: '',
        });
        this.userList = res?.list;
      });

      getRequest(`/api/eda/common/admin/getProjectList?offset=0&limit=999`).then((res) => {
        res?.list.unshift({
          id: '',
          name: this.$t('logManagement.all'),
        });
        this.projectList = res?.list;
      });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     */
    onCurrentChange(page) {
      this.currentPage = page;
      this.vuePagination();
    },

    // 前端分页
    vuePagination() {
      // allData为全部数据，tableData是目前表格绑定的数据
      this.tableData = this.getClsLogList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.vuePagination();
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.log_table {
  height: calc(100% - 120px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
}

.pagination {
  padding: 20px 10px;
  background: #fff;
  text-align: right;

  ::v-deep .el-pagination__total {
    float: left;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}

.select-width__230 {
  width: 230px !important;
  margin-right: 10px;
}
</style>
